/* unplugin-vue-components disabled */import script from "./newOrderIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./newOrderIndex.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__